import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import Banner from "../../assets/images/appImages/img-banner.png";
import Deco from "../../assets/images/appImages/deco.png";

function BannerHomepage() {
  let location = useLocation();
  let path = location?.pathname;
  return (
    <section className="section-banner-homepage">
      <div className="row align-items-center">
        <div className="col-md-6 col-left-banner-accueil mb-3">
          <div className="content-col-left-banner-accueil">
            <h2 className="title-home-page">
              <span>Pour</span>
            </h2>
            <h2 className="title-home-page">
              <span>Tout vos divers</span>
            </h2>
            <h2 className="title-home-page">
              <span>Abonnements</span>
            </h2>
            <div className="content-text-home-page-banner mt-2 mb-4">
              <p className="text-home-page-banner">
                KRA, khadim Rassoul Abonnement
              </p>
            </div>
            <div className="container-btn-banner-accueil">
              <NavLink className="btn btn-title-home-page" to="/produits">
                Voir nos abonnements
              </NavLink>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-right-banner-accueil">
          <div className="content-col-right-banner-accueil">
            <div className="container-img-col-right-banner-accueil">
              <img
                loading="lazy"
                src={Banner}
                alt="Banniere"
                className="img-col-right-banner-accueil"
              />
            </div>
            <div className="container-img-deco-banner">
              {/*  */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BannerHomepage;
